import { concat } from '@ember/helper';
import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import { t } from 'ember-intl';
import HotelShortTermRentalFixedKpiHeaderItem from 'lumen/components/hotel/short-term-rental/fixed-kpi-header-item';
import {
  BEDS,
  KPIS,
  LISTINGS,
  OCCUPANCY,
  RATE,
} from 'lumen/utils/constants/short-term-rental-constants';
import { fixedScrollHeader } from 'lumen/utils/decorators/fixed-scroll-header';

import styles from './fixed-kpi-header.module.css';

const sortOrder = [LISTINGS, BEDS, OCCUPANCY, RATE];

interface HotelShortTermRentalFixedKpiHeaderSignature {
  Args: {
    isLoading: unknown;
    kpis: unknown;
  };
}

// @ts-expect-error: Incorrect type
@fixedScrollHeader({ scrollTopTrigger: 200 })
export default class HotelShortTermRentalFixedKpiHeader extends Component<HotelShortTermRentalFixedKpiHeaderSignature> {
  @service declare access: Services['access'];

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get headerItems() {
    if (this.args.isLoading) {
      return [{}, {}, {}, {}];
    }

    const kpis = {};
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    this.args.kpis?.forEach((obj) => {
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
      obj.forEach((kpi) => {
        // @ts-expect-error: Incorrect type
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        if (!kpis[kpi.type]) {
          // @ts-expect-error: Incorrect type
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
          kpis[kpi.type] = {};
        }
        // @ts-expect-error: Incorrect type
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        kpis[kpi.type][kpi.subtype] = kpi;
      });
    });
    // @ts-expect-error: Incorrect type
    const items = [];
    Object.keys(kpis).forEach((kpi) => {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      const firstFormattedValue =
        // @ts-expect-error: Incorrect type
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        kpis[kpi].relevant?.formattedValue ??
        // @ts-expect-error: Incorrect type
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        kpis[kpi].shorttermrental?.formattedValue;
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      const secondFormattedValue =
        // @ts-expect-error: Incorrect type
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        kpis[kpi].total?.formattedValue ?? kpis[kpi].ownhotel?.formattedValue;

      items.push({
        kpi: KPIS.find((x) => x.CATEGORY === kpi),
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        firstFormattedValue,
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        secondFormattedValue,
        showSecondValue: kpi !== 'occupancy' || this.access.hasOTB,
      });
    });
    // @ts-expect-error: Incorrect type
    items.sort(
      (a, b) =>
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access
        sortOrder.indexOf(a.kpi.CATEGORY) - sortOrder.indexOf(b.kpi.CATEGORY),
    );
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return items;
  }

  <template>
    {{! @glint-expect-error: Incorrect type }}
    <div class="{{styles.wrapper}} {{if this.showHeader styles.visible}} ">
      <div class={{styles.content}}>
        {{#unless @isLoading}}
          {{#each this.headerItems as |headerItem|}}
            <HotelShortTermRentalFixedKpiHeaderItem
              @kpiCategoryFirst={{t headerItem.kpi.FIRST_SUB_CATEGORY}}
              @kpiCategorySecond={{t headerItem.kpi.SECOND_SUB_CATEGORY}}
              @showSecondValue={{headerItem.showSecondValue}}
              @title={{t
                (concat "short_term_rental.kpi." headerItem.kpi.CATEGORY)
              }}
              @valueFirst={{headerItem.firstFormattedValue}}
              @valueSecond={{headerItem.secondFormattedValue}}
            />
          {{/each}}
        {{/unless}}
      </div>
    </div>
  </template>
}
